import React from 'react'
import './register-tile.css'


const RegisterTile = ({title, subTitle, color, body, tier}) => {

    const features = [
        'NSN Procurement History',
        'Price History',
        'Alternative Part Numbers',
        'Criticality',
        'Past Performance by Cage',
        'End Item Usage',
        'AMSC Codes'
    ]

    const signupClick = () => {
        window.location.href = '/Register?tier=' + tier;
    };

    return (
        <div className='register-tile-outer-div'>
            <div className='register-tile-title'>{title}</div>
            <div className='register-tile-subtitle'>{subTitle}</div>
            <div className='register-tile-body'>{body}</div>
            <button className='register-tile-button' onClick={signupClick} style={{backgroundColor: color}}>
                Get Started
            </button>
            <ul className='register-tile-feature-list'>
                {features.map((feature) => {
                    return <li className='register-tile-feature'>{feature}</li>
                })}
            </ul>
        </div>
    )
}

export default RegisterTile